import React from "react";
import { withRouter } from "react-router-dom";
import NavigationDrawer from "react-md/lib/NavigationDrawers";
import SelectField from "react-md/lib/SelectFields";
import Avatar from "react-md/lib/Avatars";
import { FontIcon } from "react-md";
import Helper from "util/Helper";
import EventService from "service/event/EventService";
import AuthenticationService from "service/auth/AuthenticationService";

import GlobalLoader from "components/common/GlobalLoader";

import Brand from "components/brand/Brand";
import AccountMenu from "components/account-menu/AccountMenu";
import { V2Crumbs, V2Account, isV2Route } from "components/v2-chrome/v2TopBar";

import { navItems } from "constants/Navigation";

import "./drawer.css";

class NavDrawer extends React.Component {
  constructor(props) {
    super(props);

    this.helper = new Helper();
    this.authenticationService = new AuthenticationService();

    this.state = {
      visible: false,
      position: "left",
      user: this.authenticationService.getUserProfile()
    };

    this._navItems = navItems.map(item => {
      if (!item.divider) {
        item.onClick = () => {
          this._setPage(item.key);
        };
      }
      return item;
    });
  }

  componentDidMount() {
    EventService.on("updateNavigation", args => {
      this._activatePage(args.key);
    });
  }

  render() {
    const user = this.state.user;
    let name = "User";
    if (user && user.employeeProfile) {
      name = user.employeeProfile.name;
    } else if (user && user.doctorProfile) {
      name = user.doctorProfile.name;
    }

    const drawerHeaderChildren = [
      <Avatar
        key={"1"}
        src={""}
        role="presentation"
        iconSized
        style={{
          alignSelf: "center",
          marginLeft: 16,
          marginRight: 16,
          flexShrink: 0
        }}
      />,
      <SelectField
        id="account-switcher"
        menuItems={[name]}
        defaultValue={name}
        key="account-switcher"
        position={SelectField.Positions.BELOW}
        className="md-select-field--toolbar"
      />
    ];

    const toolbarActions = (
      <div>
        <AccountMenu
          simplifiedMenu={false}
          image={null}
          name={"User"}
          onClickLogout={this._logout}
        />
      </div>
    );

    const v2 = isV2Route(
      this.props.location ? this.props.location.pathname : ""
    );

    return (
      <NavigationDrawer
        temporaryIcon={<FontIcon id="menue_open">menu</FontIcon>}
        persistentIcon={<FontIcon id="menue_close">arrow_back</FontIcon>}
        navItems={this._navItems}
        contentClassName="md-grid"
        drawerHeaderChildren={drawerHeaderChildren}
        mobileDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
        tabletDrawerType={NavigationDrawer.DrawerTypes.PERSISTENT_MINI}
        desktopDrawerType={NavigationDrawer.DrawerTypes.PERSISTENT_MINI}
        /* ROUTE-AWARE, deliberately narrow (Nittin, 2026-08-21). The revamped
           screens' board draws ONE 64px bar — breadcrumb left, user right —
           where bridge draws its toolbar and then a separate breadcrumb row
           inside each v2 screen. Matching the board means putting the crumbs in
           here; this toolbar wraps every screen in the employee branch, so the
           v2 layout is swapped in only for v2 routes and every legacy screen
           gets byte-for-byte what it got before. See components/v2-chrome. */
        toolbarTitle={v2 ? <V2Crumbs /> : <Brand />}
        toolbarActions={v2 ? <V2Account /> : null}
        toolbarChildren={<GlobalLoader />}
        toolbarThemeType={v2 ? "clear" : "themed"}
        toolbarClassName={v2 ? "title-bar is-v2" : "title-bar"}
        contentId="main-content"
      >
        {this.props.children}
      </NavigationDrawer>
    );
  }

  _setPage = key => {
    this._navItems = this._navItems.map(item => {
      if (!item.divider) {
        item.active = item.key === key;
      }
      return item;
    });

    this.helper.navigateTo(this.props, key);
  };

  _activatePage = key => {
    this._navItems = this._navItems.map(item => {
      if (!item.divider) {
        item.active = item.key === key;
      }
      return item;
    });
  };

  _logout = () => {
    this.authenticationService.logout();
    this.helper.navigateTo(this.props, "/login");
  };
}

export default withRouter(NavDrawer);
